function PrivacyPolicy({
  goBack
}) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          backgroundColor: "#ffd600",
          border: "none",
          padding: "12px 20px",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "900px",
          margin: "30px auto",
          backgroundColor: "white",
          borderRadius: "25px",
          padding: "35px",
          boxShadow:
            "0 8px 25px rgba(0,0,0,0.3)"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#000"
          }}
        >
          🔒 Privacy Policy
        </h1>

        <p
          style={{
            lineHeight: "1.9"
          }}
        >
          MNHouseFinder respects
          your privacy and is
          committed to protecting
          your information.
        </p>

        <h2 style={{ color: "#d4a100" }}>
          📌 Information We Collect
        </h2>

        <p>
          • Contact information
        </p>

        <p>
          • House listings
        </p>

        <p>
          • Property information
        </p>

        <p>
          • User account information
        </p>

        <h2 style={{ color: "#d4a100" }}>
          📌 How We Use Information
        </h2>

        <p>
          • Connect tenants and landlords
        </p>

        <p>
          • Display property listings
        </p>

        <p>
          • Improve app performance
        </p>

        <p>
          • Provide customer support
        </p>

        <h2 style={{ color: "#d4a100" }}>
          📌 Data Protection
        </h2>

        <p>
          Your information is
          protected and will never
          be intentionally disclosed to
          third parties.
        </p>

        <h2 style={{ color: "#d4a100" }}>
          📌 User Responsibility
        </h2>

        <p>
          Users are encouraged to
          verify houses, office
          spaces and property
          information before
          making payments.
        </p>

        <h2 style={{ color: "#d4a100" }}>
          📌 Policy Updates
        </h2>

        <p>
          MNHouseFinder may update
          this policy from time to
          time as the platform grows.
        </p>

        <p
          style={{
            marginTop: "30px",
            fontWeight: "bold"
          }}
        >
          © 2026 MNHouseFinder.
          All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;